import React from 'react';
import { Router } from '@reach/router';
import Layout from '../../components/layout';
import FaqComponent from '../../components/about/Faq';

const Faq = ({ location }) => {
  const headerText =
    location.pathname === '/about/' || '/about' ? 'ABOUT iDECIDE' : null;

  return (
    <Layout headerText={headerText} heroFont="has-text-white" heroBg="fields">
      <Router>
        <FaqComponent path="/about/faq" />
      </Router>
    </Layout>
  );
};

export default Faq;
